<template>
  <section :class="['progress-wrapper', type, fissionGame]">
    <div
      class="progress-bar-wrapper"
      v-for="(item, index) in progressDatasource"
      :key="index"
      v-show="
        !(
          item.type === 'recharged' &&
          Object.keys(paymentAwardInfo).length === 0
        )
      "
    >
      <!-- 付费奖励不配置则不展示付费奖励进度轴 -->
      <div class="name">{{ item.name }}</div>
      <div :class="['progress-bar-item', item.type, item.awardType]">
        <!-- 进度条槽 -->
        <div class="progress-bar-body">
          <!-- 专门用于拉新注册进度条 -->
          <LoginAwardBar
            v-show="item.type === 'register'"
            v-for="(curr, index) in loginAwardInfo"
            :class="index === loginAwardInfo.length - 1 ? 'last-one' : ''"
            :key="index"
            :item="curr"
            :progress="registeredNum"
            :index="index"
            :length="loginAwardInfo.length"
          />
          <!-- 进度条 -->
          <div
            class="progress-bar current-progress"
            :style="{
              width: `${
                item.type === 'recharged'
                  ? (item.current_num / item.total_num) * 100 + '%'
                  : currentProgress(item.current_num) * 100 + '%'
              }`,
            }"
          >
            <!-- 进度条上方容器 -->
            <div
              :class="['top-wrapper', item.current_num === 0 ? 'no-data' : '']"
              v-show="
                item.current_reward && item.current_num !== item.total_num
              "
            >
              <div class="goods-info" v-show="item.current_num !== 0">
                <img
                  class="goods-icon"
                  v-if="item.current_reward && item.current_reward.icon"
                  v-lazy="item.current_reward.icon"
                  alt="logo"
                />
                <span class="goods-name">{{
                  item.current_reward.title || item.current_reward.award
                }}</span>
              </div>
              <span class="mark light"></span>
            </div>
            <!-- 进度条下方容器 -->
            <div
              :class="[
                'bottom-wrapper',
                item.current_num === 0 ? 'no-data' : '',
              ]"
            >
              {{ item.current_num }}
            </div>
          </div>
          <!-- 下一个目标进度条 -->
          <div
            class="progress-bar progress-bar-next"
            :style="{
              width: `${(item.next_num / item.total_num) * 100 + '%'}`,
            }"
            v-if="
              item.total_num - item.current_num > 3 // 确保接近目标数时不显示
            "
          >
            <!-- 进度条上方容器 -->
            <div
              :class="['top-wrapper', item.next_num === 0 ? 'no-data' : '']"
              v-if="item.next_reward"
            >
              <div class="goods-info">
                <img
                  class="goods-icon"
                  v-if="item.next_reward && item.next_reward.icon"
                  v-lazy="item.next_reward.icon"
                  alt="logo"
                />
                <span class="goods-name">{{
                  item.next_reward.title || item.next_reward.award
                }}</span>
              </div>
              <span class="mark"></span>
            </div>
            <!-- 进度条下方容器 -->
            <div
              :class="['bottom-wrapper', item.next_num === 0 ? 'no-data' : '']"
              v-if="item.next_num"
            >
              {{ item.next_num === 1 ? item.next_num : item.next_num - 2 }}
            </div>
          </div>
          <!-- 进度条槽上方容器 -->
          <div class="parent-top-wrapper" v-show="item.type !== 'register'">
            <span
              :class="[
                'mark',
                item.current_num === item.total_num ? 'light' : '',
              ]"
            ></span>
          </div>
          <!-- 进度条槽下方容器 -->
          <div class="parent-bottom-wrapper">{{ item.total_num }}</div>
        </div>
        <div
          class="finished-result-wrapper"
          :class="fissionGame"
          v-if="item.finish_reward"
        >
          <div class="goods-info">
            <img
              class="goods-icon"
              v-if="item.finish_reward && item.finish_reward.icon"
              v-lazy="item.finish_reward.icon"
              alt="logo"
            />
            <span class="goods-name">{{
              item.finish_reward.title || item.finish_reward.award
            }}</span>
            <!-- 下面这里加 v-show 是为了在 sub_title 为空时不占据空间，否则视觉上无法与左侧进度条的下方文案对齐 -->
            <span class="goods-subName" v-show="item.finish_reward.sub_title">{{
              item.finish_reward.sub_title
            }}</span>
          </div>
        </div>
      </div>
      <div
        class="split-line"
        v-if="index !== progressDatasource.length - 1"
      ></div>
    </div>
  </section>
</template>
<script>
  import { mapState } from 'vuex'
  import { priceFormat } from '@/utils/priceFormat.js'
  import { textFormat } from '@/utils/pluralRules.js'
  import { styleInfo } from '@/pages/Activity/Fission/configData.js'

  export default {
    components: {
      LoginAwardBar: () => import('./bar.vue'),
    },
    props: {
      configs: {
        type: Object,
        default: () => {},
      },
      progressDatas: {
        type: Object,
        default: () => {},
      },
      type: {
        type: String,
        default: 'page', // page: 页面, popup: 弹框
      },
      awardList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        loginConfigInfos: {},
        paymentConfigInfos: {},
        paymentedConfigInfos: {},
        textFormat: textFormat,
      }
    },
    computed: {
      ...mapState(['fissionGame', 'region']),
      loginMaxAward() {
        // 计算拉新用户注册奖励封顶人数与最大奖励对应的图标
        const registerInfos =
          this.awardList.filter((item) => item.conditionType * 1 === 3) || []
        const maxInfos =
          [...registerInfos].sort(
            (a, b) => b.conditionCount - a.conditionCount
          )[0] || {}
        const finish_reward = this.getAwardInfo(
          maxInfos,
          'register',
          'max-award'
        )
        return {
          total_num: maxInfos.conditionCount,
          finish_reward,
        }
      },
      loginAwardInfo() {
        //活动条件类型：1：初始奖励 2：首次分享奖励 3：新用户注册奖励 4：新用户付费奖励 5：新用户付费封顶奖励
        // 新用户注册奖励,注册奖励可能配置了多个
        return this.awardList
          .filter((item) => item.conditionType * 1 === 3)
          .map((item) => {
            return {
              name: this.$t('fission.registered-bonus'),
              current_num: item.conditionCount,
              total_num: this.loginMaxAward.total_num,
              current_reward: this.getAwardInfo(item, 'register'),
            }
          })
      },
      paymentAwardInfo() {
        // 付费奖励
        return (
          (this.awardList.filter((item) => item.conditionType * 1 === 4) ||
            [])[0] || {}
        )
      },
      maxPaymentAwardInfo() {
        // 付费封顶奖励
        return (
          (this.awardList.filter((item) => item.conditionType * 1 === 5) ||
            [])[0] || {}
        )
      },
      registeredNum() {
        const { registerCount = 0, registerFirstPayCount = 0 } =
          this.progressDatas || {}
        return registerCount + registerFirstPayCount || 0
      },
      progressDatasource() {
        // "firstPayCount": 仅首次付费用户数量
        // "registerCount": 仅新注册数量
        // "registerFirstPayCount": 新注册且首次付费用户数量
        const {
          firstPayCount = 0,
          registerCount = 0,
          registerFirstPayCount = 0,
        } = this.progressDatas || {}
        const { loginMaxAward, paymentAwardInfo, maxPaymentAwardInfo } = this
        // 注册的进度条数据
        const register_progress_datas = {
          type: 'register',
          name: this.$t('fission.registered-bonus'),
          current_num: registerCount + registerFirstPayCount || 0,
          current_reward: {
            icon: '',
            title: '',
          },
          ...loginMaxAward,
        }
        // 支付的进度条数据
        const that = this
        function getTitleDatas(num) {
          // 优惠券奖励 1 立减券 2折扣券
          const { awardType } = paymentAwardInfo || {}
          if (awardType * 1 === 3) {
            return ' x ' + num
          } else {
            return that.formatNumber(num * paymentAwardInfo.awardCount) || ''
          }
        }
        const awardClass = {
          3: 'coupon',
          4: 'diamond',
          5: 'kgold',
        }
        const recharged_progress_datas = {
          type: 'recharged',
          awardType: awardClass[paymentAwardInfo.awardType],
          name: this.$t('fission.first-recharge-bonus'),
          current_num: firstPayCount + registerFirstPayCount || 0,
          // 下一次的目标，实际上是firstPayCount + registerFirstPayCount + 1 但是在页面上会和当前的数据重合显示不下，因此会多加2
          next_num:
            firstPayCount + registerFirstPayCount === 0
              ? firstPayCount + registerFirstPayCount + 1
              : firstPayCount + registerFirstPayCount + 3 || 0,
          total_num: maxPaymentAwardInfo.conditionCount || 0,
          current_reward: {
            ...this.getAwardInfo(paymentAwardInfo, 'payment'),
            title: getTitleDatas(firstPayCount + registerFirstPayCount),
          },
          // 下一个奖励数据
          next_reward: {
            ...this.getAwardInfo(paymentAwardInfo, 'payment', 'next-award'),
            title: getTitleDatas(firstPayCount + registerFirstPayCount + 1),
          },
          finish_reward: {
            ...this.getAwardInfo(maxPaymentAwardInfo, 'payment', 'max-award'),
          },
        }
        let result = []
        if (this.loginAwardInfo.length) {
          result.push(register_progress_datas)
        }
        // 如果没有新用户付费奖励，则不展示付费的进度条
        if (!(paymentAwardInfo && Object.keys(paymentAwardInfo).length === 0)) {
          result.push(recharged_progress_datas)
        }
        return result
      },
    },
    watch: {},
    methods: {
      currentProgress(currNum) {
        if (this.awardList && this.awardList.length === 0) {
          return 0
        }
        const list =
          this.awardList
            .filter((item) => item.conditionType * 1 === 3)
            .sort((a, b) => a.conditionCount - b.conditionCount) || [] // 升序排列

        const awardCount = list.length
        if (currNum * 1 === 0 || awardCount < 1) {
          return 0
        }
        if (awardCount === 1) {
          return currNum / list[0].conditionCount
        }
        const fraction = 1 / awardCount
        // 若当前拉新人数少于最近一个奖品要求的拉新数量
        if (currNum < list[0]?.conditionCount) {
          return (currNum * fraction) / list[0]?.conditionCount
        }
        let leftIndex, leftNum, rightNum
        for (let i = 0; i < awardCount; i++) {
          if (
            currNum >= list[i]?.conditionCount &&
            currNum <= list[i + 1]?.conditionCount
          ) {
            leftNum = list[i]?.conditionCount
            rightNum = list[i + 1]?.conditionCount
            leftIndex = i
          }
        }
        return (
          (leftIndex + 1) * fraction +
          ((currNum - leftNum) / (rightNum - leftNum)) * fraction
        )
      },
      getAwardInfo(data, progressType, showType) {
        if (!data) return {}
        // 兼容三种奖励类型：优惠券、商品、T币
        // 跟运营确认过：注册奖励及其封顶奖励只可能是同一种奖品类型，付费奖励及其封顶奖励也只可能是同一种奖品类型
        const {
          conditionCount,
          awardType,
          couponType,
          couponPrice,
          awardCount,
          couponDiscount,
        } = data
        if (awardType * 1 === 3) {
          // 优惠券奖励 1 立减券 2折扣券
          let str = ''
          if (couponType * 1 === 1) {
            // 展示金额格式化
            str = priceFormat(couponPrice, this.region, {
              minimumFractionDigits: 0,
            })
          }
          if (couponType * 1 === 2) {
            str = 100 - couponDiscount * 1 + '% OFF' //展示的折扣
          }
          const isPaymentMaxAward =
            showType === 'max-award' && progressType === 'payment'
          str = (isPaymentMaxAward ? '+ ' : '') + str
          let title = ''
          if (isPaymentMaxAward) {
            const { awardType, couponPrice, couponType, couponDiscount } =
              this.paymentAwardInfo || {}
            if (awardType * 1 === 3) {
              if (couponType * 1 === 1) {
                const str = priceFormat(couponPrice, this.region, {
                  minimumFractionDigits: 0,
                })
                title = `${str} x ${conditionCount}`
              } else {
                title = `${100 - couponDiscount * 1}% OFF x ${conditionCount}`
              }
            }
          }
          const icon = styleInfo[this.fissionGame].icon.progressBarCoupon
          return {
            title,
            sub_title: progressType === 'payment' ? str : '',
            award: str,
            icon,
          }
        } else if (awardType * 1 === 4) {
          // 商品奖励
          const is_mlbb_max_award =
            this.fissionGame === 'mobile-legends' && showType === 'max-award'
          const { awardCount: paymentAward } = this.paymentAwardInfo
          const skuAwardDisplayed =
            progressType === 'payment' // 判断是否为付费奖励
              ? paymentAward * conditionCount // 付费进度条的商品奖励需要累积显示
              : awardCount // 注册进度条上的商品奖励无需累积显示

          // this.textFormat(this.$t('fission.diamonds'), skuAwardDisplayed)
          return {
            award: is_mlbb_max_award
              ? skuAwardDisplayed + ' Diamonds'
              : skuAwardDisplayed,
            icon: require(`@/assets/images/activities/fission/${
              this.fissionGame
            }/${
              showType === 'max-award' // 区分封顶奖励图标（置于进度条最右边的）
                ? this.fissionGame === 'mobile-legends' // 当前只有 mlbb 区分注册与付费的奖励图标
                  ? progressType + '-award__sku'
                  : 'award__sku'
                : 'score-icon'
            }.png`),
            sub_title:
              is_mlbb_max_award && progressType === 'payment'
                ? `+${awardCount || 0} Bonus`
                : '',
          }
        } else if (awardType * 1 === 5) {
          // K 币奖励
          const {
            awardCount: paymentAward,
            awardType,
            couponDiscount,
            couponType,
            couponPrice,
          } = this.paymentAwardInfo
          const skuAwardDisplayed =
            progressType === 'payment' // 判断是否为付费奖励
              ? paymentAward * conditionCount // 付费进度条的商品奖励需要累积显示
              : awardCount // 注册进度条上的商品奖励无需累积显示
          const isCoupon = awardType * 1 === 3
          return {
            award: (() => {
              if (showType === 'max-award') {
                // 封顶奖励
                if (isCoupon && progressType === 'payment') {
                  // 这里的判断针对的是付费奖励为优惠券但付费封顶奖励为T币的情况，但一般不会混搭奖励类型
                  if (couponType * 1 === 1) {
                    // 立减券
                    return `${conditionCount}*${priceFormat(
                      couponPrice,
                      this.region,
                      {
                        minimumFractionDigits: 0,
                      }
                    )}`
                  } else {
                    // 折扣券
                    return `${conditionCount}*${100 - couponDiscount * 1}% OFF`
                  }
                } else {
                  return this.textFormat(
                    this.$t('fission.kcoins'),
                    this.formatNumber(skuAwardDisplayed)
                  )
                }
              }
              return this.formatNumber(skuAwardDisplayed)
            })(),
            icon:
              isCoupon && progressType === 'payment'
                ? styleInfo[this.fissionGame].icon.progressBarCoupon
                : styleInfo.common.icon.kGold,
            sub_title:
              showType === 'max-award' && progressType === 'payment'
                ? '+' +
                  this.textFormat(
                    this.$t('fission.kcoins'),
                    this.formatNumber(awardCount)
                  )
                : '',
          }
        }
      },
      formatNumber(val) {
        // 用于不带货币符号的数额格式化
        return priceFormat(val, this.region, {
          style: 'decimal',
          minimumFractionDigits: 0,
        })
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
